import { Component, OnInit,  } from '@angular/core';

import { Router , ActivatedRoute} from '@angular/router';
import * as moment from 'moment';
import { MatSnackBar, MatDialog , MatDialogRef} from '@angular/material';
import { TagprescriptionComponent } from '../../common/tagprescription/tagprescription.component';
import { Users } from '../../classes/users';
import { DoctorService } from '../../services/doctor.service';
@Component({
  selector: 'app-appointmentdetail',
  templateUrl: './appointmentdetail.component.html',
  styleUrls: ['./appointmentdetail.component.css']
})
export class AppointmentdetailComponent implements OnInit {
  appointid: number;
  appointment: any
  userdata: Users[];
  service: any;
  pet: any;
  utime: any;
  public loading = false;
  msg1: any;
  action: any;
  tagdocument: any;
  p = 1;
  constructor(private route: ActivatedRoute, private doctorservice:  DoctorService,
    private snackbar: MatSnackBar, private dialog: MatDialog) {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.appointid = id;
       });
  }

  ngOnInit() {
    this.getTime();
    this.loading = true;
    this.doctorservice.getAppointmentDetail(this.appointid)
    .subscribe(
      (x) => {
        this.loading = false;
        this.appointment = x;
        this.getAppointmentuser(this.appointment[0].user_id);
        this.getService(this.appointment[0].service_id);
        this.getPetDetail(this.appointment[0].pet_id);
      });
     this.getAppointmentTaggedDocument();
  }
  getAppointmentTaggedDocument() {
    this.doctorservice.getAppointmentTaggedDocuments(this.appointid)
    .subscribe(
      (x) => {
        this.tagdocument = x;
      });
  }
  getService(sid) {
    this.doctorservice.getService(sid)
    .subscribe(
      (x) => {
        this.service = x;
      });
   }
   getPetDetail(pid) {
    this.doctorservice.getparticulerPetdetail(pid)
    .subscribe(
      (x) => {
        this.pet = x;
      }
    );
   }
  getAppointmentuser(id) {
    this.doctorservice.getAppointmentmentUserDetail(id)
    .subscribe(
      (x) => {
        this.userdata = x;
      });
     }
     cancellAppointment(id) {
      this.doctorservice.cancelAppointment(id)
      .subscribe(
        (x) => {
         this.appointment[0].status = 4;
        });
    }
    getTime() {
      this.doctorservice.getTime()
      .subscribe(
        (d) => {
          const ctime = d.date;
          const css = moment(ctime.date);
          const cs =  moment.utc(css);
          this.utime = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
        });
    }
    iscancellable(dat , stime) {
      const converstime = moment(dat + '/'  + stime);
      const cs = moment.utc(converstime);
      const uti = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
      return uti;
     }
  cancelAppointment(apid, dat , stime) {
      this.loading = true;
      const nt = this.iscancellable( dat , stime)
      this.doctorservice.getTime()
      .subscribe(
        (d) => {
          const ctime = d.date;
          const css = moment(ctime.date);
          const cs =  moment.utc(css);
          this.utime = moment(cs, 'MM-DD-YYYY hh:mm:ss').unix() * 1000;
          this.checkPosibility(nt , apid);
        });
    }
    checkPosibility(nt , apid) {
     if (nt > this.utime) {
       this.cancellFinally(apid);
     }else {
       this.loading = false;
       this.msg1 = 'Cancellation not possible';
       this.openSnackBar();
     }
    }
    uploadpresCription() {
      const dialogRef = this.dialog.open(TagprescriptionComponent, {
        width: '400px',
        height: '150px',
      } );
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.uploadIntoDb(result);
        }
      });
    }
    uploadIntoDb(result) {
      this.loading = true;
       const sub = 'Doctor send it';
       const type = 'prescription';
      this.doctorservice.uploadUserpetDocument(this.pet.id, sub, type, result, this.appointid)
      .subscribe(
       (x) => {
        this.loading = false;
         this.msg1 = 'prsecription Upload successfully';
         this.openSnackBar();
         this.getAppointmentTaggedDocument();
       });
      }
    cancellFinally(apid) {
     this.doctorservice.cancellAppointment(apid)
     .subscribe (
       (x) => {
         this.appointment = x;
         this.msg1 = 'Appointment Cancelled Successfully';
         this.loading = false;
         this.openSnackBar();
       }
     );
    }
    openSnackBar() {
     this.snackbar.open(this.msg1 , this.action, {
       duration: 4000,
     });
    }
    getFileExtension(fname) {
      return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
    }
}
